// extracted by mini-css-extract-plugin
export default {"label":"Label_label__UgUZo","peer":"Label_peer__gvTS1"};